import React, {useState, useEffect} from 'react';
import './BoxChamp.css';
import { apiLink, classementAPI, getLongNameChamp } from '../variables';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import {
    IoIosArrowUp
} from "react-icons/io";

// livescores : rencontres du jour du livescoring, indexées par renc_id ({ status, score… })
function BoxChamp({championnat, livescores = {}}) {
    const navigate = useNavigate();
    const [currentOnglet, setCurrentOnglet] = useState(1);
    const [classement, setClassement] = useState(null);
    const [matchs, setMatchs] = useState(null);
    const [parsedMatch, setParsedMatch] = useState([]);
    const [currentDay, setCurrentDay] = useState(1);

   

    useEffect(() =>  {
        getClassement()
        getMatchs();
    }, [])

    const getClassement = async () => {
        const link = classementAPI.find(item => item.for === championnat).link;
        if (link !== '') {
            axios
            .get(link, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then(function(res) {
                setClassement(res.data);
            })
            .catch(function(error) {
                console.log(error);
            });
        } 
    }

    const getMatchs = async () => {
        const link = apiLink.find(item => item.for === championnat).link;
        if (link !== '') {
            axios
            .get(link, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then(function(res) {
                var data = res.data;
                setMatchs(data);
                parseMatch(data);
                calculateCurrentDay(data)
            })
            .catch(function(error) {
                console.log(error);
            });
        } 
    }

    const parseMatch = (data, day = currentDay) => {
        let arrayDate = [];
        const tmpDate = [];
        // on insère les dates
        data.forEach((item) => {
            let tour = item.libelle.toString();
            tour = parseInt(tour.split('°')[1].split(' ')[0]);
            if (day === tour) {
                let date = item.datereelle.toString();
                // date = date.split('du')[1].trim();
                date = new Date(date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0]);
                if (!tmpDate.includes(date.toString())) {
                    arrayDate.push({date: date, dataIndex: []});
                    tmpDate.push(date.toString());
                }
            }
        })

        // On tri le tableau par ordre croissant
        arrayDate.sort((a, b) => a.date - b.date);

        // on insère les matchs par date
        arrayDate.forEach(function(obj) {
            data.forEach((item, index) => {
                let tour = item.libelle.toString();
                tour = parseInt(tour.split('°')[1].split(' ')[0]);
                if (day === tour) {
                    let dateMatch = item.datereelle.toString();
                    dateMatch = new Date(dateMatch.split('/')[2] + '-' + dateMatch.split('/')[1] + '-' + dateMatch.split('/')[0]);
                    if (obj.date.getTime() === dateMatch.getTime()) {
                        obj.dataIndex.push(index);
                    }
                }
            })
        })
        setParsedMatch(arrayDate);
    }

    const getCurrentHighestDay = (matchs) => {
        const today = new Date();
        let currentHighestDay = 1;

        matchs.forEach((match) => {
            // on récupère la date du match
            let date = match.datereelle.toString();
            date = new Date(date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0]);
            // on récupère la journée
            const day = parseInt(match.libelle.toString().split('°')[1].split(' ')[0]);

            // on veut connaître la journée atteinte à la date d'aujourd'hui
            // si la date du match n'est toujours pas arrivé
            // alors on passe au suivant;
            if (date > today) return;

            if (day > currentHighestDay) {
                currentHighestDay = day;
            }
        });

        return currentHighestDay;
    }

    const calculateCurrentDay = (matchs) => {
        const today = new Date();
        const matchParsed = [];
        const currentHighestDay = getCurrentHighestDay(matchs);

        // Pour chaque match
        matchs.forEach((match) => {
            // on récupère la date du match
            let date = match.datereelle.toString();
            date = new Date(date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0]);
            // on récupère la journée
            const day = parseInt(match.libelle.toString().split('°')[1].split(' ')[0]);
            // si la date est < today alors on ne la compte pas dans le calcul
            if (date < today + 1) return;
            // si la journée du match est déjà passé alors on ne la compte pas dans le calcul
            // cette ligne est pour pallier aux exceptions où certains matchs se jouent à une journée X avec une date éloignée des autres
            if (day < currentHighestDay) return;
            // on push
            matchParsed.push({
                date,
                day
            });
        });

        // Si tous les matchs ont été joués
        // on retourne la dernière journée
        if (matchs.length > 0 && matchParsed.length === 0) {
            return getMaxDayChampionnat();
        }

        const neareastMatch = matchParsed.sort((a, b) => {
            const dateDifferenceA = Math.abs(a.date - today);
            const dateDifferenceB = Math.abs(b.date - today);
        
            // Si les dates sont égales, comparez par jour
            if (dateDifferenceA === dateDifferenceB) {
                return a.day - b.day;
            }
        
            return dateDifferenceA - dateDifferenceB;
        })[0];
        
        // on calcule la date la plus proche
        // const neareastMatch = matchParsed.reduce((a, b) => Math.abs(a.date - today) < Math.abs(b.date - today) ? a : b) || 1;
        // on change à la date la plus proche
        return handleChangeDay(neareastMatch.day, matchs);
    }


    const getMaxDayChampionnat = (m = matchs) => {
        let maxDayChampionnat = 1; 
        m.forEach((match) => {
            // on récupère la journée
            const day = parseInt(match.libelle.toString().split('°')[1].split(' ')[0]);
            if (day > maxDayChampionnat) {
                maxDayChampionnat = day;
            }
        });
        return maxDayChampionnat;
    }

    const info = (index, value) => {
        return classement[index][value];
    }

    const infoMatch = (index, value) => {
        return matchs[index][value] || '';
    }

    // Identifiant SPID de la rencontre, lu dans son lien (comme la page Calendrier)
    const getRencId = (index) => {
        const match = infoMatch(index, 'lien').match(/renc_id=(\d+)/);
        return match ? match[1] : null;
    }

    // Ouvre la rencontre dans le calendrier, déroulée, comme un clic sur une carte « Aujourd'hui »
    const goToMatch = (rencId) => {
        navigate('/' + championnat + '/calendrier', { state: { goTo: rencId } });
    }

    const handleChangeDay = (day , m = matchs) => {
        let maxDayChampionnat = getMaxDayChampionnat(m);

        if (day > maxDayChampionnat) {
            day = maxDayChampionnat;
        }

        if (day < 1) {
            day = 1
        }

        setCurrentDay(day);
        parseMatch(m, day);
        return true;
    }

    // "PARIS 13 TT 1" -> "PARIS 13 TT" : on retire seulement le numéro d'équipe final
    // (l'ancien split('1') coupait au premier "1" du nom)
    const nomEquipe = (nom) => nom.replace(/\s+1$/, '');

    const maxDay = matchs ? getMaxDayChampionnat(matchs) : 1;

    return (
        <div className={"box_champ_component " + championnat}>
            <div className="box_title">
                <span className="box_title_label">Championnat</span>
                <span className="box_title_name">{getLongNameChamp(championnat)}</span>
            </div>
            <div className="box_onglet" role="tablist">
                <button type="button" role="tab" aria-selected={currentOnglet === 1} className={currentOnglet === 1 ? "active" : ""} onClick={()=>setCurrentOnglet(1)}>Calendrier</button>
                <button type="button" role="tab" aria-selected={currentOnglet === 2} className={currentOnglet === 2 ? "active" : ""} onClick={()=>setCurrentOnglet(2)}>Classement</button>
            </div>
            <div className="box_content">
                {
                    currentOnglet === 1 &&
                    <div className="box_calendar">
                        <div className="box_calendar_day">
                            <button type="button" className="box_day_arrow" aria-label="Journée précédente" disabled={currentDay <= 1} onClick={()=>handleChangeDay(currentDay - 1)}>
                                <IoIosArrowUp size={18} style={{transform: 'rotate(-90deg)'}} />
                            </button>
                            <span className="box_calendar_day_label">Journée {currentDay}</span>
                            <button type="button" className="box_day_arrow" aria-label="Journée suivante" disabled={currentDay >= maxDay} onClick={()=>handleChangeDay(currentDay + 1)}>
                                <IoIosArrowUp size={18} style={{transform: 'rotate(90deg)'}} />
                            </button>
                        </div>
                        <div className="box_calendar_matchs">
                            {
                                parsedMatch.map((item,index) => {
                                    return (
                                        <div key={index} className="box_calendar_date">
                                            <span className="box_calendar_date_span">{item.date.toLocaleDateString("fr-FR", { weekday: 'long', day: 'numeric', month: 'long' })}</span>
                                            {
                                                item.dataIndex.map((data) => {
                                                    const rencId = getRencId(data);
                                                    // Livescoring du jour pour cette rencontre (en cours / terminée)
                                                    const live = rencId ? livescores[rencId] : undefined;
                                                    const enDirect = live?.status === 'en_cours';
                                                    const [liveA, liveB] = (live?.score || '').split('-').map((s) => parseInt(s, 10));
                                                    const hasLiveScore = !isNaN(liveA) && !isNaN(liveB);

                                                    const joue = infoMatch(data, "scorea") !== "" && infoMatch(data, "scoreb") !== "";
                                                    // Score affiché : en direct > officiel > livescoring terminé (score officiel pas encore publié)
                                                    let scoreA = parseInt(infoMatch(data, 'scorea'));
                                                    let scoreB = parseInt(infoMatch(data, 'scoreb'));
                                                    if ((enDirect || (!joue && live?.status === 'termine')) && hasLiveScore) {
                                                        scoreA = liveA;
                                                        scoreB = liveB;
                                                    }
                                                    const termine = !enDirect && (joue || (live?.status === 'termine' && hasLiveScore));
                                                    const afficheScore = termine || (enDirect && hasLiveScore);

                                                    // Cliquable uniquement s'il y a quelque chose à voir : résultat ou direct
                                                    const clickable = rencId && (termine || enDirect);
                                                    return (
                                                        <div
                                                            key={data}
                                                            className={"box_calendar_match" + (clickable ? " clickable" : "") + (enDirect ? " live" : "")}
                                                            role={clickable ? "link" : undefined}
                                                            tabIndex={clickable ? 0 : undefined}
                                                            title={clickable ? (enDirect ? "Suivre la rencontre en direct" : "Voir la rencontre") : undefined}
                                                            onClick={clickable ? () => goToMatch(rencId) : undefined}
                                                            onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goToMatch(rencId); } } : undefined}
                                                        >
                                                            <span className={"box_calendar_equipe home" + (termine && scoreA > scoreB ? " winner" : "")}>{nomEquipe(infoMatch(data, 'equa'))}</span>
                                                            {
                                                                afficheScore ?
                                                                <span className={"box_calendar_time score" + (enDirect ? " live" : "")} title={enDirect ? "Score en direct" : undefined}>
                                                                    {enDirect && <span className="box_calendar_live_dot" aria-hidden="true" />}
                                                                    {scoreA} - {scoreB}
                                                                </span>
                                                                :
                                                                <span className="box_calendar_time">{infoMatch(data, "heurereelle") || "VS"}</span>
                                                            }
                                                            <span className={"box_calendar_equipe away" + (termine && scoreB > scoreA ? " winner" : "")}>{nomEquipe(infoMatch(data, 'equb'))}</span>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <button type="button" className="box_span_details" onClick={()=>navigate('/'+championnat+'/calendrier')}>
                            Tout le calendrier <span aria-hidden="true">→</span>
                        </button>
                    </div>
                }
                {
                    currentOnglet === 2 &&
                    <div className="box_classement">
                        <table>
                            <thead>
                                <tr>
                                    <th className="box_classement_pos">#</th>
                                    <th>Club</th>
                                    <th className="td_pts">Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    classement !== null &&
                                    classement.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="box_classement_pos"><span>{info(index, 'clt')}</span></td>
                                                <td className="box_classement_club">{info(index, 'equipe')}</td>
                                                <td className="td_pts">{info(index, 'pts')}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                        <button type="button" className="box_span_details" onClick={()=>navigate('/'+championnat+'/classement')}>
                            Classement complet <span aria-hidden="true">→</span>
                        </button>
                    </div>
                }
            </div>
        </div>
    );
}

export default BoxChamp;